import { TriggerFoundationFilter, configuredTriggerTimespan, isZeroTimespan, } from '@debbie/common/dist/procedures/index.js';
// "At expiration" or e.g. "3 months before expiration".
export const timingText = (lang, configuration) => {
    const timespan = configuredTriggerTimespan(configuration);
    return isZeroTimespan(timespan)
        ? lang.procedures.atExpiration
        : `${timespan[0]} ${lang.timespanUnits[timespan[1]]} ${lang.procedures.beforeExpiration}`;
};
export const foundationFilterLabels = (lang) => ({
    [TriggerFoundationFilter.Any]: lang.procedures.foundationFilterAny,
    [TriggerFoundationFilter.WithFoundation]: lang.procedures.foundationFilterWithFoundation,
    [TriggerFoundationFilter.WithoutFoundation]: lang.procedures.foundationFilterWithoutFoundation,
});
export const foundationFilterOf = (configuration) => configuration.settings.foundationFilter ?? TriggerFoundationFilter.Any;
//# sourceMappingURL=labels.js.map